import React = require('react');
import Dialog from "material-ui/Dialog";
import diyLightTheme = require('diy/material-ui/diyLightTheme');
import Data = require("../../util/websiteData");

import l10n from 'diy/util/l10n';
import {DialogActions} from "../DialogController";
import {TranslationRequest, TranslationResponse} from "./FrameTranslation";

interface TransferDialogProps {
    actions?: DialogActions;
}

export default class TransferDialog extends React.Component<TransferDialogProps, {}> {

    static childContextTypes: React.ValidationMap<any> = {
        muiTheme: React.PropTypes.object
    };

    getChildContext() {
        return {
            muiTheme: diyLightTheme
        };
    }

    componentDidMount() {
        /** Receive keys from the animation's frame and send the corresponding translation back */
        window.addEventListener("message", function(event: MessageEvent) {
            try {
                let request: TranslationRequest = event.data;

                if (request.type === "translations") {
                    let response: TranslationResponse = {
                        type: "translations",
                        params: {
                            key: request.params.key,
                            value: l10n(request.params.key)
                        }
                    };
                    event.source.postMessage(response, event.origin);
                }

            } catch (error) {
                console.error('Error in sending translation: "' + error + '"');
            }
        });
    }

    render(): JSX.Element {
        let cdnUrl: string = Data.getCdnUrl();
        let animationPath: string = cdnUrl + "s/diy/externalwebsiteimport/transferDialog/animation/index.html";

        return (
            <Dialog open={true}
                    autoScrollBodyContent={true}
                    contentClassName="migration-dialog transfer-dialog"
                    bodyClassName="dialog-body"
                    actionsContainerClassName="dialog-actions"
                    actions={this.props.actions}
                    style={{zIndex: diy.editor.getNewTopZIndex()}}>

                <div className="transfer-dialog-animation-container">
                    <div className="transfer-dialog-animation">
                        <iframe
                            src={animationPath}
                            scrolling="no"
                            style={{width: "100%", height: "100%", border: "none"}}
                        ></iframe>
                    </div>
                </div>
                {this.props.children}
            </Dialog>
        );
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/externalwebsiteimport/transferDialog/TransferDialog.tsx
 **/